import React, { useMemo } from 'react'
import { useRouter } from 'next/router'

import KinerjaKSPerencanaanApp from 'app/KinerjaKSPage/pages/Perencanaan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerjaKS'
import ContentProvider from 'app/KinerjaKSPage/components/ContentProvider'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { parseQuery } from 'utils/router'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import PageGuardKs from 'app/KinerjaKSPage/components/PageGuardKs'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { Jenjang } from 'types/kinerja'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ks-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

const KinerjaKSPerencanaan = ({}) => {
  const router = useRouter()

  const npsn = useMemo(() => {
    // If router is not ready, return null
    if (!router.isReady) return null

    return parseQuery<string>(router.query.id) as string
  }, [router?.isReady, router?.query?.id])

  const { data: { data: skp } = {}, isFetched: isSkpFetched } = useAPIKinerja(
    npsn,
    { enabled: router.isReady && !!npsn }
  )

  return (
    <PageGuardKs>
      <KinerjaTipeProvider tipe="SPF">
        <ContentProvider
          jenjang={skp?.jenjang as Jenjang}
          isSkpFetched={isSkpFetched}
        >
          <SchoolProvider>
            <KinerjaKSPerencanaanApp skp={skp} isSKPFetched={isSkpFetched} />
          </SchoolProvider>
        </ContentProvider>
      </KinerjaTipeProvider>
    </PageGuardKs>
  )
}

KinerjaKSPerencanaan.Layout = KinerjaLayout

KinerjaKSPerencanaan.layoutOpts = {
  hasHeader: true,
}

export default KinerjaKSPerencanaan
